import { useEffect, useState } from 'react'
import { subscribeWorkspacePulseEvents, type WorkspacePulseEvent } from '../../../../services/aiAgentBridge'

export interface UseWorkspacePulseEventsParams {
  workspaceId: string
  refreshKey?: number
}

export interface UseWorkspacePulseEventsResult {
  events: WorkspacePulseEvent[]
  loading: boolean
  error: Error | null
}

export const useWorkspacePulseEvents = ({
  workspaceId,
  refreshKey,
}: UseWorkspacePulseEventsParams): UseWorkspacePulseEventsResult => {
  const [events, setEvents] = useState<WorkspacePulseEvent[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!workspaceId) {
      setEvents([])
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    const unsubscribe = subscribeWorkspacePulseEvents(
      workspaceId,
      (incomingEvents) => {
        setEvents(incomingEvents)
        setLoading(false)
      },
      (err) => {
        setError(err)
        setLoading(false)
      },
    )

    return () => {
      unsubscribe()
    }
  }, [workspaceId, refreshKey])

  return { events, loading, error }
}
